import type { WorkspaceAppManifest } from './workspaceManifest';

export const APP_MANIFEST = {
    appId: 'auto-dealers',
    permissionsPrefix: 'auto-dealers',
    displayName: 'Auto Dealers',

    navSections: [
        { key: 'dashboard', label: 'Dashboard', route: '/auto-dealers/dashboard' },
        { key: 'sales',     label: 'Sales',     route: '/auto-dealers/sales' },
        { key: 'setup',     label: 'Setup',     route: '/auto-dealers/setup' },
        { key: 'reports',   label: 'Reports',   route: '/auto-dealers/reports' },
    ],

    resources: [
        { key: 'vehicleSaleInfo',        label: 'Vehicle sale info',    navSection: 'sales' },
        { key: 'vehicleSaleInfoPosting', label: 'Vehicle sales — unpost', navSection: 'sales' },
        { key: 'dispatchInfo',           label: 'Vehicle dispatch',     navSection: 'sales' },
        { key: 'vehicleReceivedInfo',    label: 'Vehicle receive',      navSection: 'sales' },
        { key: 'vehicleReceivedInfoPosting', label: 'Vehicle receive — unconfirm', navSection: 'sales' },
        { key: 'salesServiceInfo',   label: 'Sales service info',  navSection: 'sales' },
        { key: 'variantInformation', label: 'Vehicle variant',     navSection: 'setup' },
        { key: 'colorInformation',   label: 'Color information',   navSection: 'setup' },
        { key: 'vehicleGroupInfo',   label: 'Vehicle group info',  navSection: 'setup' },
        { key: 'genBankInformation', label: 'Bank information',    navSection: 'setup' },
        { key: 'reports',            label: 'Reports',             navSection: 'reports' },
    ],
} satisfies WorkspaceAppManifest;
